export const zh = {
  'generator-title-apa6' : '免费 · APA · 第6版 参考文献格式自动生成器',
  'generator-title-apa7' : '免费 · APA · 第7版 参考文献格式自动生成器',
  'generator-title-mla7' : '免费 · MLA · 第7版 参考文献格式自动生成器',
  'generator-title-mla8' : '免费 · MLA · 第8版 参考文献格式自动生成器',
  'generator-title-chicago' : '免费 · 芝加哥 · 第17版 参考文献格式自动生成器',
  'generator-title-vancouver' : '免费 · 温哥华参考文献格式自动生成器',
  'generator-description-apa6' : '免费生成APA (第6版、第7版) 参考文献格式，为书籍、期刊和网络资料自动创建引用，复制粘贴至参考文献列表即可，简单方便，无广告干扰！',
  'generator-description-apa7' : '免费生成APA(第6版、第7版) 参考文献格式，为书籍、期刊和网络资料自动创建引用，复制粘贴至参考文献列表即可，简单方便，无广告干扰！',
  'generator-description-mla7' : '免费生成MLA (第7版、第8版) 参考文献格式，为书籍、期刊和网络资料自动创建引用，复制粘贴至参考文献列表即可，简单方便，无广告干扰！',
  'generator-description-mla8' : '免费生成MLA(第7版、第8版) 参考文献格式，为书籍、期刊和网络资料自动创建引用，复制粘贴至参考文献列表即可，简单方便，无广告干扰！',
  'generator-description-chicago' : '免费生成Chicago芝加哥 (第17版) 参考文献格式，为书籍、期刊和网络资料自动创建引用，复制粘贴至参考文献列表即可，简单方便，无广告干扰！',
  'generator-description-vancouver' : '免费生成Vancouver温哥华参考文献格式，为书籍、期刊和网络资料自动创建引用，复制粘贴至参考文献列表即可，简单方便，无广告干扰！',
  'Brand Name' : 'Wordvice',
  'Citation Generator' : '参考文献格式自动生成器',
  'Contributors': '贡献者',
  'Page Name' : '网页标题',
  'Site Name' : '网站名称',
  'Date Published' : '出版日期',
  'Date Accessed' : '访问日期',
  'Publisher' : '出版社',
  'Publisher Name' : '出版社名称',
  'Publication Info' : '出版信息',
  'Publication Location' : '出版地点',
  'Publication Year' : '出版年份',
  'Day' : '日',
  'Month' : '月',
  'Year' : '年',
  'Generate' : '作成する',
  'button_generate' : '生成',
  'Copied.' : '已复制',
  'copied_messgage' : '复制完成',
  'generate_result' : '生成结果',
  'Article Title' : '文章标题',
  'Journal Title' : '期刊标题',
  'Edition' : '版号',
  'Volume' : '卷号',
  'Issue' : '期号',
  'Number' : '编号',
  'Pages' : '页码',
  'Website or Database Title' : '网站或数据库名',
  'Title' : '标题',
  'Location' : '出版地点',
  'cite-Source' : '出处来源',
  'cite-Style' : '格式',
  'Copy' : '复制',
  'Delete' : '删除',
  'Number or name' : '编号或名称',
  'source-Website' : '电子文献或网站网址',
  'source-Journal Article' : '期刊文章',
  'source-Book' : '图书专著',
  'site_desc' : '选择一种引用样式，输入相关信息后，即可自动生成符合标准的参考文献。',
  'Example' : '示例',
  'Format' : '格式',
  'Citation Style Guides' : '引用格式指南',
  'Author Last Name' : '作者姓氏',
  'Author First Name' : '作者名字',
  'Author First Initial' : '名字首字母',
  'Author Middle Name' : '中间名字',
  'Author Middle Initial' : '中间名首字母',
  'Website Name' : '网站名称',
  'Print' : '印刷版',
  'Digital' : '电子版',
  'Page Title' : '网页标题',
  'Published Year' : '出版年份',
  'Published Date' : '出版日期',
  'citation-desc' : "选择一种引用风格，输入相关信息，点击 \"生成 \"按钮，即可自动生成符合相关标准的参考文献格式。所有生成结果将集中显示在网页中间位置。您可直接复制粘贴至参考文献页使用，也可随时从列表中删除不必要的项目。",
  'author' : '作者',
  'editor' : '编辑',
  'translator' : '译者',
  'First Name' : '名字',
  'Middle' : '中间名',
  'Last Name' : '姓氏',
  'Quick Guides' : '引用格式指南',
  'APA Citation Guide' : 'APA格式引用指南',
  'MLA Citation Guide' : 'MLA格式引用指南',
  'Chicago Citation Guide' : 'Chicago格式引用指南',
  'Vancouver Citation Guide' : 'Vancouver格式引用指南',
  'Style Guide Introduction' : '参考文献格式生成器',
  
  "apa" : {
    "page-title" : "APA 参考文献格式自动生成器(免费)",
    "page-description" : "选择一种引用风格，输入相关信息，点击 \"生成 \"按钮，即可自动生成符合相关标准的参考文献格式。所有生成结果将集中显示在网页中间位置。您可直接复制粘贴至参考文献页使用，也可随时从列表中删除不必要的项目。",
    "meta-title" : "APA 参考文献格式自动生成器(免费)",
    "meta-description" : "免费生成APA (第6版、第7版) 参考文献格式，为书籍、期刊和网络资料自动创建引用，复制粘贴至参考文献列表即可，简单方便，无广告干扰！",
  },
  
  "mla" : {
    "page-title" : "MLA 参考文献格式自动生成器(免费)",
    "page-description" : "MLA格式是人文学科，如文化研究、英语、文学和批判理论等学科的作者和学生准备稿件时常用的引文格式。 我们的MLA参考文献格式自动生成器可免费为您自动生成准确的MLA第7版和第8版格式。阅读MLA引用格式快速指南，详细了解参考文献页规则和内文引注规则。",
    "meta-title" : "MLA 参考文献格式自动生成器(免费)",
    "meta-description" : "免费生成MLA (第7版、第8版) 参考文献格式，为书籍、期刊和网络资料自动创建引用，复制粘贴至参考文献列表即可，简单方便，无广告干扰！",
  },
  
  "chicago" : {
    "page-title" : "芝加哥 · 第17版 参考文献格式自动生成器(免费)",
    "page-description" : "Chicago芝加哥格式主要用于艺术、人文和社会科学领域。 我们的Chicago芝加哥参考文献格式自动生成器可免费为您准确自动生成最新的Chicago芝加哥第17版格式。阅读Chicago芝加哥引用格式快速指南，详细了解参考文献页规则和内文引注规则。",
    "meta-title" : "芝加哥 · 第17版 参考文献格式自动生成器(免费)",
    "meta-description" : "免费生成Chicago芝加哥 (第17版) 参考文献格式，为书籍、期刊和网络资料自动创建引用，复制粘贴至参考文献列表即可，简单方便，无广告干扰！",
  },
  
  "vancouver" : {
    "page-title" : "温哥华参考文献格式自动生成器(免费)",
    "page-description" : "Vancouver温哥华格式被包括IEEE和MEDLINE在内的数百种科学期刊采用。科学期刊在参考文献格式要求方面有自己的作者指南，很多指南都遵循“作者-编号体系”的逻辑。 阅读Vancouver温哥华引用格式快速指南，详细了解引用规则。",
    "meta-title" : "温哥华参考文献格式自动生成器(免费)",
    "meta-description" : "免费生成Vancouver温哥华参考文献格式，为书籍、期刊和网络资料自动创建引用，复制粘贴至参考文献列表即可，简单方便，无广告干扰！",
  },
  
  // sidebar
  "Citation Sources" : "Citation Sources",
  "citation_sources" : {
    "link1" : {
      "uri" : "https://blog.wordvice.cn/youtube-video-citation-apa-mla-chicago-vancouver/",
      "title" : "如何引用YouTube视频？",
    },
    "link2" : {
      "uri" : "https://blog.wordvice.cn/how-to-cite-images-apa-mla-chicago-vancouver/",
      "title" : "如何引用图片和数字图像？",
    },
    "link3" : {
      "uri" : "https://blog.wordvice.cn/how-to-cite-movie-apa-mla-chicago-vancouver/",
      "title" : "如何引用电影？",
    },
    "link4" : {
      "uri" : "https://blog.wordvice.cn/how-to-cite-a-website-apa-mla-chicago-vancouver/",
      "title" : "如何引用网站和网页？",
    },
    "link5" : {
      "uri" : "https://blog.wordvice.cn/how-to-cite-a-podcast-apa-mla-chicago-vancouver/",
      "title" : "如何引用播客(podcast)？",
    },
    "link6" : {
      "uri" : "https://blog.wordvice.cn/how-to-cite-chatgpt-sources-apa-mla-chicago-vancouver/",
      "title" : "如何引用ChatGPT？",
    },
    "link7" : {
      "uri" : "https://blog.wordvice.cn/how-to-cite-a-book-apa-mla-chicago-vancouver-style/",
      "title" : "如何引用书籍？",
    },
  }
};



// WEBPACK FOOTER //
// ./src/lang/zh.js